import { TradeOrderStatusEnum } from '@sparling/financial-common'

const orderStatus = []

// eslint-disable-next-line guard-for-in,no-restricted-syntax
for (const status in TradeOrderStatusEnum) {
  orderStatus.push({
    value: status,
    label: TradeOrderStatusEnum[status as keyof typeof TradeOrderStatusEnum],
  })
}

export const ORDER_STATUS = orderStatus
